import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateDiaryChiftInvoicingLinkController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateDiaryChiftInvoicingLinkController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-invoicing'
*/
const UpdateDiaryChiftInvoicingLinkController = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDiaryChiftInvoicingLinkController.url(args, options),
    method: 'put',
})

UpdateDiaryChiftInvoicingLinkController.definition = {
    methods: ["put"],
    url: '/api/accounting-diary/{accounting_diary}/partners/chift-invoicing',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateDiaryChiftInvoicingLinkController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateDiaryChiftInvoicingLinkController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-invoicing'
*/
UpdateDiaryChiftInvoicingLinkController.url = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_diary: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { accounting_diary: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_diary: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_diary: typeof args.accounting_diary === 'object'
        ? args.accounting_diary.id
        : args.accounting_diary,
    }

    return UpdateDiaryChiftInvoicingLinkController.definition.url
            .replace('{accounting_diary}', parsedArgs.accounting_diary.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateDiaryChiftInvoicingLinkController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateDiaryChiftInvoicingLinkController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-invoicing'
*/
UpdateDiaryChiftInvoicingLinkController.put = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDiaryChiftInvoicingLinkController.url(args, options),
    method: 'put',
})

export default UpdateDiaryChiftInvoicingLinkController